<template>
    <div id="returnMaterialSave">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px"class="hewidth">
                <el-input clearable v-model.trim="searchForm.orderNo" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable v-model="searchForm.belonger" placeholder="退料人">
                    <el-option v-for="(item,index) in pickingUserAllList"
                        :label="item.name"
                        :value="item.name"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable v-model="searchForm.createUser" placeholder="创建人">
                    <el-option v-for="(item,index) in operatorUserAllList"
                        :label="item.staffName"
                        :value="item.staffName"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:22%;margin-bottom:15px">
                <el-date-picker
                    style="width: 100%;"
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="width:30%; margin-bottom: 15px;" >
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 20px;cursor: pointer;margin-left: 5px;" @click="refresh()"></i>
            </el-form-item>
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                    
                </el-col>
            </el-form-item> -->
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        type="index"
                        width="50"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="inventoryCode"
                        width="100"
                        label="序列号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="modelName"
                        width="150"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        width="230"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="orderNo"
                         width="180"
                        label="订单号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="maintainPrice"
                        label="维修金额">
                    </el-table-column>
                    <el-table-column
                        align="center"
                         width="155"
                        label="退料时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.pickTime">{{scope.row.pickTime | date}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="engineerName"
                        label="退料人">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {
        returnMaterialDetailsList,
        queryUser,
        engineerList
    } from "../../api/api";
    export default {
        name: 'returnMaterialSave',
        components: {},
        data () {
            return {
                valueTime3:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    orderNo: '',       //关联订单号
                    createUser: '',    //操作人
                    belonger:'',       //退料人
                    createTimeFrom:'', //提交开始时间
                    createTimeTo:'',   //提交结束时间
                },
                returnData: [],
                pickingUserAllList:[],
                operatorUserAllList:[]
            }
        },
        created(){
            this.returnMaterialDetailsList();
            this.getOperatorUserAllList();
            this.getPickingEngineerList();
        },
        methods: {
            getPickingEngineerList(){
                let para={
                        status:1,
                        startRow: 1,
                        pageSize: 10000
                }
                engineerList(para).then(res => {
                    if (res.data.status==100) {
                        this.pickingUserAllList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearFrom(){
                this.searchForm = {}
                this.valueTime3 = []
            },
            //获取退料自留列表
            returnMaterialDetailsList(){
                let para={
                    isRetenRetain: 1,
                    orderNo:this.searchForm.orderNo,
                    belonger:this.searchForm.belonger,
                    createUser: this.searchForm.createUser,
                    createTimeFrom: this.searchForm.createTimeFrom,
                    createTimeTo: this.searchForm.createTimeTo,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                returnMaterialDetailsList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.returnMaterialDetailsList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.returnMaterialDetailsList()
            },
            refresh() {
                this.searchForm = {};
                this.valueTime3 = [];
                this.returnMaterialDetailsList();
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.createTimeFrom = ''
                            this.searchForm.createTimeTo = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.createTimeFrom = ''
                            this.searchForm.createTimeTo = ''
                        }else{
                            this.searchForm.createTimeFrom = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.createTimeTo = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.returnMaterialDetailsList()

                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #returnMaterialSave{
        font-size: 14px;
        .el-form-item{
            margin-bottom:15px
        }
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
    }
 .hewidth {
        width: 13% !important;
      }
</style>



// WEBPACK FOOTER //
// returnMaterialSave.vue?61fe8789